export default __webpack_public_path__ + "static/media/warning--skiers--g1.e4cb5a02.png";